const FULLVALUE = 12;

export const getResizedChartWidth = (maxChartWidth, breakpointWidth = 768, decrement = 50) => {
  return window.outerWidth > breakpointWidth ? maxChartWidth : window.outerWidth - decrement;
};

export const convertGridToDecimal = (grid) => {
  if (grid >= 12 || grid < 1) {
    return 1;
  }
  return grid / FULLVALUE;
};

export const getLineChartWidth = (maxChartWidth, grid = FULLVALUE) => {
  const multiplier = convertGridToDecimal(grid);
  const xs = 0;
  const md = 900;
  const lg = 1200;
  const xl = 1536;
  const windowWidth = window.outerWidth;
  if (windowWidth >= xl) {
    return maxChartWidth;
  }
  if (windowWidth >= lg) {
    return windowWidth * multiplier * 0.70;
  }
  if (windowWidth >= md) {
    return windowWidth * multiplier * 0.74;
  }
  if (windowWidth >= xs) {
    return windowWidth - 50;
  }
};
